import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import { ESCALATION_FEATURE_KEY, EscalationCollectionState, EscalationTimer } from '../escalation-collection.state';
import { NotificationStateUtilities } from '../../utilities/notification-state-utlities';
import { NotificationIdState } from '../../utilities/notification-id.type';

export const selectEscalationFeature = createFeatureSelector<EscalationCollectionState>(ESCALATION_FEATURE_KEY);

export const selectEscalationTimerEntries: MemoizedSelector<object, EscalationTimer[]> = createSelector(
    selectEscalationFeature,
    (state) => state.timerEntries,
);

export const selectEscalationStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectEscalationFeature,
    (state) => state.status,
);

export const selectEscalationLoaded: MemoizedSelector<object, boolean> = createSelector(
    selectEscalationFeature,
    (state) => state.status === LoadStatus.Loaded,
);

/**
 * Factory selector: returns `true` when a timer entry exists for the given notification.
 * Used by `checkEscalationRequired$` to avoid scheduling duplicate timers.
 *
 * @param notificationId
 */
export const selectEscalationTimerExists = (notificationId: NotificationIdState): MemoizedSelector<object, boolean> =>
    createSelector(selectEscalationTimerEntries, (entries) =>
        entries.some((entry) => NotificationStateUtilities.compare(entry.notificationId, notificationId)),
    );

/**
 * Factory selector: returns the `setTimeout` handle for the given notification, or
 * `undefined` when no timer is registered.
 *
 * @param notificationId
 */
export const selectEscalationTimerHandle = (
    notificationId: NotificationIdState,
): MemoizedSelector<object, number | undefined> =>
    createSelector(
        selectEscalationTimerEntries,
        (entries) =>
            entries.find((entry) => NotificationStateUtilities.compare(entry.notificationId, notificationId))
                ?.timerHandle,
    );
